import React, { Component } from "react";
import styled from "styled-components";

const FuenteP = styled.p`
   font-size: 0.8em;
   padding-bottom: 2em;
`;

export default class Fuente extends Component {
	render() {
		return (
			<FuenteP>
				Predicción del tiempo de OpenWeather Map.
			</FuenteP>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Fuente.js